import React from "react";
import ActivityCard from "./ActivityCard";
import { Activity, Hostage } from "../types";
import { useUser } from "../../context/UserContext";
import "../../style/ActivityList.css";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type ActivityListProps = {
  activities: Activity[];
  hostages: Hostage[];
  showLink?: boolean;
  registeredUsersMap: Record<string, number>,
  onRefresh?: () => void;
  onJoin?: (activityId: string) => void;
  onUndoJoin?: (activityId: string) => void;
};

const ActivityList: React.FC<ActivityListProps> = ({
                                                     activities: activities,
                                                     hostages: hostages,
                                                     showLink = false,
                                                     registeredUsersMap,
                                                     onRefresh,
                                                     onJoin,
                                                     onUndoJoin
                                                   }: ActivityListProps) => {
  const { user } = useUser();
  const { t } = useTranslation();
  const navigate = useNavigate();

  function getEventOwner(event: Activity): Hostage {
    return hostages.filter(x => event.hostages.includes(x.id))[0];
  }

  function getHostageByEvent(event: Activity): Hostage {
    return event.isPublic ? hostages[0] : getEventOwner(event);
  }

  if (activities?.length === 0) {
    return null;
  }

  return (
    <div className="activitiesContainer">
      {activities?.map(event => (
        <ActivityCard
          key={event.id}
          activity={event}
          hostage={getHostageByEvent(event)}
          eventOwner={getEventOwner(event)}
          showLink={!event.isPublic && showLink}
          numOfRegisteredUsers={(event.id && registeredUsersMap[event.id]) || 0}
          onRefresh={onRefresh}
          onJoin={onJoin}
          onUndoJoin={onUndoJoin}
        />
      ))}
    </div>
  );
};

export default ActivityList;